import { NgFor, NgIf, NgTemplateOutlet } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { RouterLink, RouterLinkActive, RouterModule } from '@angular/router';
import { I18nService } from '@app/i18n';
import { SharedModule } from '@shared';
import { AngularSvgIconModule } from 'angular-svg-icon';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    RouterLink,
    RouterLinkActive,
    AngularSvgIconModule,
    SharedModule,
    NgFor,
    NgIf,
    NgTemplateOutlet,
  ],
})
export class FooterComponent implements OnInit {
  currentLang?: string;
  supportLanguages = this.i18nService.supportedLanguageObjects;

  constructor(private i18nService: I18nService) {}

  ngOnInit(): void {
    this.currentLang = this.i18nService.langName;
  }

  changeLanguage(language: string) {
    this.i18nService.language = language;
  }
}
